import get from 'lodash/get'
import { debug } from '@bt-react/libs/Logger'

export default async function getVideoCapabilities (deviceId = ''): Promise<MediaTrackCapabilities> {

  const userMediaConstraints = deviceId ? { video: { deviceId } } : { video: true }
  let userMedia: MediaStream
  let mediaStreamTrack: MediaStreamTrack[]

  try {

    userMedia = await navigator.mediaDevices.getUserMedia(userMediaConstraints)

  }
  catch (e) {

    debug(get(e, 'message', ''))
    return {}

  }

  try {

    mediaStreamTrack = await userMedia.getVideoTracks()

  }
  catch (e) {

    debug(get(e, 'message', ''))
    return {}

  }

  if (get(mediaStreamTrack, 'length', 0) === 0) return {}

  const [ track ] = mediaStreamTrack

  if (!Reflect.has(track || {}, 'getCapabilities')) return {}

  const constraints = track.getCapabilities()
  track.stop()

  return constraints

}
